module.exports = __webpack_public_path__ + "media/3-12.ee5fd543.wav";